import { eHocKyDangKyActionsObj } from "../../action-types/category/IHocKyDangKyActions";
import { generateActions } from "../generateActions";

export const hocKyDangKyActions = {
    ...generateActions(eHocKyDangKyActionsObj, "HOC_KY_DANG_KY"),
}